import {AfterViewInit, Component} from '@angular/core';
import {PcrInterviewFragmentController} from './PcrInterviewFragmentController';
import {DateUtil} from '../../../../../Util/DateUtil';
import {MatDialog} from '@angular/material/dialog';
import {BaseViewUI} from '../../../../BaseUI/BaseViewUI/BaseViewUI';
import {Router} from '@angular/router';
import {PopoverConfirmComponent} from '../../../../Common/Popover/Confirm/PopoverConfirmComponent';
import {HtmlStringConst} from '../../../../../Enum/HtmlStringConst';

/**
 * PcrInterviewFragmentComponent
 * 問診画面
 */
@Component({
	selector: 'app-pcr-interview-component',
	templateUrl: './PcrInterviewFragmentComponent.html',
	styleUrls: ['./PcrInterviewFragmentComponent.scss'],
})
export class PcrInterviewFragmentComponent extends BaseViewUI implements AfterViewInit {

	// 紐付いたコントローラー
	public combineCtrl: PcrInterviewFragmentController;

	// メイン画面を表示するイベント
	public eventShowMain: any;

	public questionList: any = [];

	// 問診票
	public interviewModel: {
		express: any;
		cert: any;
		positiveCert: any;
		type: any;
		group: any;
		date: string;
		name: string;
		passportNo: string;
		nationality: number;
	} = {
		express: false,
		cert: null,
		positiveCert: null,
		type: null,
		group: null,
		date: DateUtil.getDateString(new Date()),
		name: null,
		passportNo: null,
		nationality: null
	};

  	// 検体番号
	public specimenNumber: number;

	// 備考欄
	public pcrExamineRemark = '';


	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog,
				public route: Router) {

		super();

		// コントローラーの生成
		this.createController(PcrInterviewFragmentController);

	}

	/**
	 * ngAfterViewInit
	 *
	 * Angularのライフサイクル
	 * ビューの初期化後に一度だけ実行される
	 */
	public async ngAfterViewInit() {
		// 自分の初期化処理実行
		await this.start();
	}

	/**
	 * 開始処理
	 */
	public async start() {

		// ログイントークンが存在しているかをチェックする
		// 失敗するとログイン画面
		const ret = await this.combineCtrl.isExistToken(this);
		if (!ret) {
			// ログイン時に問診画面を表示するためリファラセット
			await this.combineCtrl.setReferrer(this);
			// ログイン画面表示
			await this.route.navigate(['login']);
			return;
		}

		// 問診データの受け取りを行う
		this.questionList = await this.execUserFuncWithErrorHandling(
			this,
			this.combineCtrl.getPcrInterviewMstList.bind(this),
			{view: this}
		);

	}

	/////////////////////////////////////
	// 画面イベント
	/**
	 * saveInterview
	 * 問診登録
	 */
	public async saveInterview() {

		const errMsg = this.combineCtrl.checkInputData(this.interviewModel);
		if(errMsg.length > 0) {
			this.showAlertDialog('エラー', errMsg.join(HtmlStringConst.BR));
			return;
		}

		// 問診登録処理
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.savePcrInterview.bind(this),
			{view: this, data: this.interviewModel, specimenNum: this.specimenNumber, pcrExamineRemark: this.pcrExamineRemark}
		);
		if (!ret) {
			return;
		}

		history.replaceState(null, null, '');

		await this.showDialogWindow(
			PopoverConfirmComponent,
			{
				title: '確認',
				text: '問診を登録しました。OKボタンを押してください。',
				close: this.confirmReceive.bind(this)
			}
		);

	}
	public async confirmReceive() {
		await this.dismissDialogWindow();
		await this.route.navigate(['']);
	}
}

